import { Select, Wrap } from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../i18n';
import { FormulasV2, LouiseOffer } from '../../../../../../types/Quotes';
import { getProductKey } from '../../../services/offersService';
import { addToQuoteSpecifications } from '../../../store/redux/slices/offersSlice';
import { useLouiseDispatch } from '../../../store/redux/store';

interface Props {
  offer: LouiseOffer;
  formulas: FormulasV2;
}

const OfferFormulas: React.FC<Props> = ({ offer, formulas }) => {
  const louiseDispatch = useLouiseDispatch();

  const handleChange = (
    key: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    louiseDispatch(
      addToQuoteSpecifications({
        productKey: getProductKey(offer),
        quoteId: offer.hash_id,
        value: {
          modifications: [
            {
              name: key,
              formula: e.currentTarget.value,
            },
          ],
        },
      }),
    );
  };

  return (
    <Wrap>
      {Object.entries(formulas).map(([key, value]) => {
        return (
          <Select key={key} maxW="80" onChange={(e) => handleChange(key, e)}>
            {value.map(({ id, name }) => (
              <option key={id} value={id}>
                {handleResponseLanguage(name)}
              </option>
            ))}
          </Select>
        );
      })}
    </Wrap>
  );
};

export default OfferFormulas;
